import { FormLayout, FormLayoutData } from "@/components/form/Forms";
import { RepositoryBase } from "./RepositoryBase";
import { AuthenticationController } from "@/controllers/AuthenticationController";
import { RouteCache } from "./RouteCache";

export class SubmitFormRequest
{
    public formData: any = {};
    public recaptchaToken = "";
}

export class  FormRepository extends RepositoryBase
{
    private baseUrl: string;
    public constructor(host: string,authenticationController: AuthenticationController, routeCache: RouteCache) {
        super(host,authenticationController,routeCache);
        this.baseUrl=host +  "/api/form"; 

    }

    public submitForm(formId: string, model: any)
    {
        return new Promise<any>( (resolve,reject)=>{
            this.request<any>("post",`${this.baseUrl}/${formId}`, model).then(r=>{ 
                resolve(r);
            }).catch( oops=>{ 
                reject();
            });
        });
    }
    
    public getForm(formId: string): Promise<FormLayoutData>{
        return new Promise<FormLayoutData>( (resolve,reject)=>{
            this.request<any>("post",`${this.baseUrl}/${formId}`).then(r=>{ 
                resolve(r);
            }).catch( oops=>{ 
                reject();
            });
        });
    }

}